if (!customElements.get('category-slider')) {
  class CategorySlider extends HTMLElement {
    constructor() {
      super()

      this._splide = new Splide(this, {
        rewind: true,
        type: 'loop',
        clones: 4,
        arrows: true,
        pagination: true,
        perPage: 1,
        lazyLoad: false,
        drag: true
      })
      this._splide.mount();
    }

    connectedCallback() {
      const liveRegionEle = this.querySelector('.category-slider-announcement');
      if (!liveRegionEle) {
        return;
      }

      this._splide.on('moved', () => {
        const activeSlide = this._splide.index + 1;
        liveRegionEle.textContent = `Slide ${activeSlide} of ${this._splide.length}`;
      })
    }
  }
  customElements.define('category-slider', CategorySlider)
}


if (!customElements.get('category-slider-auto')) {
  class CategorySliderAuto extends HTMLElement {
    constructor() {
      super()

      new Splide(this, {
        rewind: true,
        type: 'loop',
        clones: 4,
        arrows: true,
        pagination: true,
        autoplay: true,
        pauseOnHover: true,
        interval: 5000,
        perPage: 1,
        lazyLoad: false,
        drag: true
      }).mount();
    }

  }

  customElements.define('category-slider-auto', CategorySliderAuto)
}
